export default "__VITE_ASSET__CjDYj8dD__"